// extracted by mini-css-extract-plugin
module.exports = {"loyaltyHowToGainPointsModal":"loyalty-how-to-gain-points-modal_loyaltyHowToGainPointsModal__s26pb","title":"loyalty-how-to-gain-points-modal_title__pZyFh"};